import dayjs from 'dayjs';
/*
 ** Can parse ISO string date format to readable format
 */
export function improviseISOTimestamps(object) {
    if (typeof object === 'string') {
        const date = dayjs(object, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]', true);
        return date.isValid() ? date.format('MMM D, YYYY - h:mm A (Z)') : object;
    }
    else if (typeof object === 'object') {
        Object.keys(object).forEach(key => (object[key] = improviseISOTimestamps(object[key])));
        return object;
    }
}
